import { createContext, useContext } from 'react';

interface StepValidationState {
    failed: boolean;
    setFailed: (v: boolean) => void;
}

export const StepValidationContext = createContext<StepValidationState>({
    failed: false,
    setFailed: () => {}
});

export const useStepValidationFailed = () => useContext(StepValidationContext).failed;
export const useSetStepValidationFailed = () => useContext(StepValidationContext).setFailed;
